<template>
    <rkm-modal
        extraLarge
        title="Alterar agendamento"
        :loading="loading"
        :persistent=true
        ref="Modal"
    >

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                 @click="handleClose"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!isAlterado || !!loading"
                @click="alterar()"
                color="primary"
            >
                Alterar
            </rkm-button>
        </template>

        <rkm-alert v-if="paciente">

            <strong>Paciente: </strong>
            {{ paciente.nome }}
            <strong v-if="paciente.prefereNomeSocial">
                ({{ paciente.nomeSocial }})
            </strong>

            - <strong>Prontuário: </strong>
            <template v-if="paciente.prontuario">
                {{ paciente.prontuario }}
            </template>
            <template v-else>
                <i>Não informado</i>
            </template>

            - <strong>CNS: </strong>
            <template v-if="paciente.cns">
                {{ paciente.cns }}
            </template>
            <template v-else>
                <i>Não informado</i>
            </template>
        </rkm-alert>

        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >

            <rkm-area
                title="Dados da consulta"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :searchFields="localForm.autocompleteFields.motivo"
                            :repository="repositories.motivo"
                            v-model="model.motivo"
                            textField="descricao"
                            :validations="validations.motivo"
                            label="Motivo da viagem"
                            uppercase
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="$refs.ModalMotivo.open()"
                                    color="primary"
                                    title="Cadastrar motivo"
                                >
                                    <rkm-icon icon="plus" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="3" v-if="!this.model.itemsSelecionados">
                        <rkm-form-date-picker
                            label="Data"
                            v-model="model.data"
                            :validations="validations.data"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            label="Horário da Consulta/Procedimento"
                            v-model="model.horario"
                            :validations="validations.horario"
                            :disabled="!model.data"
                            right
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Município"
                            v-model="model.municipioId"
                            value-field="id"
                            text-field="nome"
                            :options="municipios"
                            :validations="validations.municipio"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="destinos"
                            text-field="descricao"
                            value-field="id"
                            label="Local"
                            v-model="model.destinoId"
                            @change="setFields('destinoId')"
                            :disabled="!model.municipio"
                            :validations="model.municipio ? validations.destino : {}"
                            show-default-option
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="$refs.ModalAgendado.open(model.data, model.municipio)"
                                    color="primary"
                                    title="Viagens agendadas"
                                    :disabled="!model.data || !model.municipio"
                                >
                                    <rkm-icon icon="search" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-select>
                    </rkm-col>

                    <rkm-col cols="12">
                        <rkm-form-textarea
                            label="Observação do transporte"
                            v-model="model.consultaObservacao"
                            name="consultaObservacao"
                            rows="1"
                            max-rows="1"
                        >
                        </rkm-form-textarea>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                title="Dados do transporte"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>

                    <rkm-col cols="2">

                        <rkm-form-select
                            :options="form.acompanhante"
                            text-field="text"
                            value-field="value"
                            :label="form.paciente && form.paciente.requiredAcompanhante ? 'Acompanhante(s) *' : 'Acompanhante(s)'"
                            v-model="model.acompanhante"
                            @change="handleAcompanhante()"
                            :validations="validations.acompanhante"
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-select
                            :options="pontos"
                            text-field="descricao"
                            value-field="id"
                            label="Ponto de referência"
                            v-model="model.pontoId"
                            :validations="validations.ponto"
                            :disabled="!model.municipio"
                            show-default-option
                            @change="handleDataSaida()"
                        />
                    </rkm-col>

                    <rkm-col cols="3" v-if="!this.model.itemsSelecionados">
                        <rkm-form-date-picker
                            label="Data saída"
                            v-model="dataSaidaUnica"
                            :max-date="formatDate()"
                            :disabled="!model.data || !model.pontoId"
                            :validations="validations.dataSaida"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            label="Horário de saída do veículo"
                            v-model="model.horarioSaida"
                            :validations="form.horarioSaida || model.horarioSaida ? validations.horarioSaida : {}"
                            :disabled="!model.dataSaida || !model.horario"
                            right
                        />
                    </rkm-col>

                    <rkm-col cols="2" v-if="agendarTransporteJornada">
                        <rkm-form-select
                            :options="form.tiposPassageiro"
                            :validations="validations.tipoPassageiro"
                            label="Tipo de passageiro"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.tipoPassageiroId"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-select
                            :options="veiculos"
                            text-field="descricao"
                            value-field="id"
                            label="Veículo"
                            v-model="model.veiculoId"
                            @change="setFields('veiculoId')"
                            :disabled="!model.tipoPassageiroId && agendarTransporteJornada || !model.municipio && !agendarTransporteJornada"
                            :validations="model.tipoPassageiroId && agendarTransporteJornada && form.veiculoObrigatorio ? validations.veiculo : {}"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col
                        cols="5"
                    >
                        <rkm-form-select
                            :options="optionsJornada"
                            text-field="descricao"
                            value-field="id"
                            label="Jornada"
                            v-model="model.jornadasSelecionadas"
                            :multiple="model.isMultiple"
                            :disabled="!model.veiculoId || updatingJornadas"
                            :validations="form.veiculoObrigatorio && agendarTransporteJornada ? validations.jornada : {}"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col
                        :cols="agendarTransporteJornada ? '2' : '3'"
                    >
                        <rkm-form-input
                            label="Agendados"
                            type="number"
                            v-model="model.totalAgendados"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Capacidade"
                            type="number"
                            v-model="model.capacidade"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.tiposVeiculo"
                            text-field="descricao"
                            value-field="id"
                            label="Tipo de veículo"
                            v-model="model.tipoVeiculoId"
                            show-default-option
                            disabled
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                v-if="form.dadosAcompanhante && model.acompanhante > 0"
                title="Acompanhante 1"
                type="fieldset"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            v-if="form.campoLivre"
                            label="Nome"
                            v-model="model.acompanhante1.nome"
                            uppercase
                            :validations="validations.nome"
                        />

                        <rkm-form-input-autocomplete
                            v-else
                            :repository="repositories.paciente"
                            :search-fields="fields.paciente"
                            :text-field="(item) => item.cidadao.nome"
                            label="Nome"
                            v-model="model.acompanhante1.nome"
                            uppercase
                            :validations="validations.nome"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="CNS"
                            v-model="model.acompanhante1.cns"
                            v-mask="mask.cns"
                            :validations="validations.cns"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="Telefone"
                            v-model="model.acompanhante1.telefone"
                            :validations="validations.telefone"
                            v-mask="mask.cellPhone"
                            :disabled="!form.campoLivre"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Relação"
                            :options="form.relacoes"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            v-model="model.acompanhante1.relacaoId"
                            :validations="validations.relacao"
                            :disabled="!model.acompanhante1.nome"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                v-if="form.dadosAcompanhante && model.acompanhante > 1"
                title="Acompanhante 2"
                type="fieldset"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            v-if="form.campoLivre"
                            label="Nome"
                            v-model="model.acompanhante2.nome"
                            uppercase
                            :validations="validations.nome"
                        />
                        <rkm-form-input-autocomplete
                            v-else
                            :repository="repositories.paciente"
                            :search-fields="fields.paciente"
                            :text-field="(item) => item.cidadao.nome"
                            label="Nome"
                            v-model="model.acompanhante2.nome"
                            uppercase
                            :validations="validations.nome"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="CNS"
                            v-model="model.acompanhante2.cns"
                            v-mask="mask.cns"
                            :validations="validations.cns"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="Telefone"
                            v-model="model.acompanhante2.telefone"
                            :validations="validations.telefone"
                            v-mask="mask.cellPhone"
                            :disabled="!form.campoLivre"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Relação"
                            :options="form.relacoes"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            v-model="model.acompanhante2.relacaoId"
                            :validations="validations.relacao"
                            :disabled="!model.acompanhante2.nome"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                title="Observação do paciente"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>

                    <rkm-col cols="12">
                        <rkm-form-textarea
                            v-model="model.observacao"
                            name="observacao"
                            rows="1"
                            max-rows="1"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <ModalMotivo
            ref="ModalMotivo"
            @alterar="loadMotivo"
        />

        <ModalAgendado
            ref="ModalAgendado"
        />

        <ModalPermissao
            ref="RkmModalPermissao"
            @handlePermission="handlePermission"
        />
    </rkm-modal>
</template>

<script>

// Moment.
import moment from 'moment'

// Mixins.
import { error, repository, stringCase, data, object, printTransportePacienteAgendar, mask } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Filters.
import format from '@/filters/formats'

// Components.
import ModalMotivo from '@/components/transporte-paciente/agendar/motivo/Modal'
import ModalAgendado from '@/components/transporte-paciente/agendar/agendados/Modal'
import ModalPermissao from '@/components/transporte-paciente/agendar/permissao/Modal'

// Utils
import validaCpf from '@/utils/validations/cpf'
import validaCns from '@/utils/validations/cns'

export default {
    components: {
        ModalMotivo,
        ModalAgendado,
        ModalPermissao
    },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
            isAlterado() {
            const dataSaidaAtual = Array.isArray(this.model.dataSaida) ? this.model.dataSaida[0] : this.model.dataSaida;
            const dataSaidaOriginal = Array.isArray(this.originalModel.dataSaida) ? this.originalModel.dataSaida[0] : this.originalModel.dataSaida;

            return (
                this.originalModel.motivo?.id !== this.model.motivo?.id ||
                this.getFormatedDate(this.originalModel.data, 'DD-MM-YYYY') !== this.getFormatedDate(this.model.data, 'DD-MM-YYYY') ||
                moment(this.originalModel.horario, 'HH:mm').format('HH:mm') !== moment(this.model.horario, 'HH:mm').format('HH:mm') ||
                this.originalModel.municipioId !== this.model.municipioId ||
                this.originalModel.destinoId !== this.model.destinoId ||
                (this.originalModel.consultaObservacao || '').trim() !== (this.model.consultaObservacao || '').trim() ||
                this.originalModel.acompanhante !== this.model.acompanhante ||
                this.originalModel.pontoId !== this.model.pontoId ||
                this.getFormatedDate(dataSaidaOriginal, 'DD-MM-YYYY') !== this.getFormatedDate(dataSaidaAtual, 'DD-MM-YYYY') ||
                moment(this.originalModel.horarioSaida, 'HH:mm').format('HH:mm') !== moment(this.model.horarioSaida, 'HH:mm').format('HH:mm') ||
                this.originalModel.tipoPassageiroId !== this.model.tipoPassageiroId ||
                this.originalModel.veiculoId !== this.model.veiculoId ||
                this.originalModel.jornadaId !== this.model.jornadaId ||
                (this.originalModel.observacao || '').trim() !== (this.model.observacao || '').trim()
            );
        },
        dataSaidaUnica: {
            get() {

                return Array.isArray(this.model.dataSaida) ? this.model.dataSaida[0] : this.model.dataSaida
            },
            set(value) {

                this.model.dataSaida = value ? this.getFormatedDate(value, 'YYYY-MM-DD') : null
            },
        },
        validations() {
            const validations = {
                motivo: { required: true },
                data: { required: true },
                horario: { required: true },
                municipio: { required: true },
                destino: { required: true },
                ponto: { required: true },
                dataSaida: { required: true },
                acompanhante: {
                    min_value: this.form.paciente && this.form.paciente.requiredAcompanhante ? 1 : 0,
                },
                horarioSaida: {
                    required: true,
                    max_hour: this.getFormatedDate(this.model.data, 'YYYY-MM-DD') === this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD')
                        ? this.getMaxHour() : false
                },
                tipoPassageiro: { required: true },
                veiculo: { required: true },
                jornada: { required: true },
                nome: { required: true },
                cns: {
                    min_max_without_mask: 15,
                    cns: true,
                },
                telefone: {
                    required: true,
                    min_max_without_mask: [10, 11]
                },
                relacao: { required: true }
            };

            if (this.model.acompanhante === 0) {

                delete validations.acompanhante;
            }

            return validations;

        },
        optionsJornada() {

            if (this.model.dataSaida && Array.isArray(this.model.dataSaida)) {

                const dataSaidaFormatada = this.model.dataSaida.map(data =>
                    this.getFormatedDate(data, 'YYYY-MM-DD')
                )

                if (!dataSaidaFormatada.length) {
                    return []
                }

                const jornadasFiltradas = this.jornadas?.filter(jornada =>
                    dataSaidaFormatada.some(dataSaida =>
                        this.getFormatedDate(jornada.dataInicial, 'YYYY-MM-DD') <= dataSaida &&
                        this.getFormatedDate(jornada.dataFinal, 'YYYY-MM-DD') >= dataSaida
                    )
                ) ?? []

                if (dataSaidaFormatada.length > 1) {
                    this.jornadasMultiplas(jornadasFiltradas)
                }

                return jornadasFiltradas;
            } else {
                const dataSaidaFormatada = this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD')

                if (!dataSaidaFormatada) {
                    return []
                }

                return this.jornadas?.filter(jornada =>
                    this.getFormatedDate(jornada.dataInicial, 'YYYY-MM-DD') <= dataSaidaFormatada &&
                    this.getFormatedDate(jornada.dataFinal, 'YYYY-MM-DD') >= dataSaidaFormatada
                ) ?? []
            }
        },
        fields() {

            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
    },
    created() {
        this.repositories.agendar = this.getConectaSusRepository('transportePaciente.agendar')
        this.repositories.motivo = this.getConectaSusRepository('transportePaciente.motivo')
        this.repositories.municipio = this.getConectaSusRepository('intranet.municipio')
        this.repositories.paciente = this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')
        this.repositories.gerenciamento = this.getConectaSusRepository('transportePaciente.gerenciamento')
    },
    data: () => ({
        item: null,
        destinos: [],
        veiculos: [],
        jornadas: [],
        tiposPassageiro: [],
        agendamentoPaciente: [],
        index: null,
        supervisorId: null,
        updatingJornadas: false,
        form: {},
        model: {
            motivo: [],
            data: null,
            horario: null,
            municipio: [],
            municipioId: null,
            destinoId: null,
            pontoId: null,
            ponto: null,
            acompanhante: null,
            dataSaida: null,
            horarioSaida: null,
            tipoPassageiroId: null,
            consultaObservacao: null,
            id: null,
            jornadaId: null,
            observacao: null,
            pacienteId: null,
            acompanhante1Id: null,
            acompanhante2Id: null,
            veiculoId: null,
            tipoVeiculoId: null,
            supervisorId: null,
            alterado: false,
            acompanhante1: {
                usuarioId: '',
                nome: '',
                cns: '',
                telefone: '',
                relacaoId: null
            },
            acompanhante2: {
                usuarioId: '',
                nome: '',
                cns: '',
                telefone: '',
                relacaoId: null
            },
            jornadasSelecionadas: [],
            itemsSelecionados: [],
            isMultiple: false,
        },
        utils: {
            validaCpf,
            validaCns
        },
        watchers: [],
        repositories: {},
        localForm: {
            autocompleteFields: {
                motivo: [
                    { key: 'descricao', searchable: true },
                ],
                municipio: [
                    {
                        key: 'nome',
                        searchable: true,
                    },
                ],
            },
        },
        fieldMap: [
            'data',
            'horario',
            'municipioId',
            'destinoId',
            'pontoId',
            'horarioSaida',
            'tipoPassageiroId',
            'veiculoId',
            'jornadaId',
            'consultaObservacao',
            'observacao'
        ],
        originalMunicipioId: null,
        originalModel: null
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions([
            'clear',
            'setCustomer',
            'setLoading',
            'unsetLoading',
        ]),
        load() {
            this.setLoading()

            this.repositories.agendar.show(this.model.pacienteId)
                .then(({ data }) => this.setData(data.form || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$nextTick().then(() => this.addWatchers())))
        },
        handleClose() {
            this.$emit('close-modal')
            this.$refs.Modal.hide()
        },
        configuraDadosDosAcompanhantes() {
            if(!this.form.campoLivre) {
                return;
            }

            if(this.model.acompanhante1.nome && this.model.acompanhante1.nome.cidadao) {
                this.model.acompanhante1.id = null;
                this.model.acompanhante1.usuarioId = null;
                this.model.acompanhante1.nome = this.model.acompanhante1.nome.cidadao.nome
                this.model.acompanhante1.cns = null
                this.model.acompanhante1.cnd = null
            }

            if(this.model.acompanhante2.nome && this.model.acompanhante2.nome.cidadao) {
                this.model.acompanhante2.id = null;
                this.model.acompanhante2.usuarioId = null;
                this.model.acompanhante2.nome = this.model.acompanhante2.nome.cidadao.nome
                this.model.acompanhante2.cns = null
                this.model.acompanhante2.cnd = null
            }

        },
        setData(form) {

            if (form) {

                this.form = Object.assign(form)
            }

            if (!this.model.veiculoId){
                this.model.jornadasSelecionadas = null
            }

            if (this.model.jornadasSelecionadas) {
                    this.$nextTick().then(() => this.handleVagas())

            }

            this.configuraDadosDosAcompanhantes();
        },
        handleVagas() {

            if (this.model.jornadaId) {

                const jornada = this.jornadas.find(jornada => jornada.id === this.model.jornadaId)

                if (jornada) {

                    this.model.capacidade = jornada.numeroCapacidade
                    this.model.totalAgendados = Number(jornada.totalAgendados)
                    this.model.tipoVeiculoId = jornada.tipoId
                }
            } else if (this.model.veiculoId) {

                const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                if (veiculo) {
                    this.model.capacidade = veiculo.capacidade
                    this.model.totalAgendados = veiculo.agendados
                        ? (Number(veiculo.agendados.quantidade) - Number(this.model.acompanhante)) - 1
                        : 0
                    this.model.tipoVeiculoId = veiculo.tipoId
                }
            }
        },
        open(item) {

            this.removeWatchers()

            this.$nextTick().then(() => this.openModal(item))
        },
        openModal(item) {

            this.model.itemsSelecionados = Array.isArray(item) ? true : false

            const items = Array.isArray(item) ? item : [item]

            if (items.length > 0) {

                const baseItem = items[0]

                this.supervisorId = null
                this.model.pacienteId = baseItem.pacienteId
                this.model.motivo = baseItem.motivo
                this.model.municipio = baseItem.municipio
                this.model.municipioId = baseItem.municipio.id

                this.getDestinos()

                this.model.data = baseItem.data
                this.model.horario = baseItem.horario
                this.model.destinoId = baseItem.destinoId
                this.model.acompanhante = baseItem.acompanhante
                this.model.acompanhante1 = baseItem.acompanhante1
                this.model.acompanhante2 = baseItem.acompanhante2
                this.model.pontoId = baseItem.pontoId
                this.model.dataSaida = items.map(item => item.dataSaida)
                this.model.horarioSaida = baseItem.horarioSaida

                this.getTiposPassageiro()

                this.model.tipoPassageiroId = baseItem.tipoPassageiroId
                this.model.consultaObservacao = baseItem.consultaObservacao

                this.getVeiculos()

                this.model.veiculoId = baseItem.veiculoId

                this.getJornadas()

                this.model.jornadaId = baseItem.jornadaId
                this.model.observacao = baseItem.observacao
                this.model.supervisorId = baseItem.supervisorId
                this.model.statusId = baseItem.statusId
                this.model.id = items.map(item => item.id)
            }

            this.cloneModel()
            this.$nextTick().then(() => this.load())
            this.$refs.Modal.show()
        },
        cloneModel(){
            this.originalModel = {}
            this.originalModel.motivo = this.model.motivo
            this.originalModel.data = this.model.data
            this.originalModel.horario = moment(this.model.horario, "HH:mm").format("HH:mm")
            this.originalModel.municipioId = this.model.municipioId
            this.originalModel.destinoId = this.model.destinoId
            this.originalModel.consultaObservacao = (this.model.consultaObservacao || '').trim()
            this.originalModel.acompanhante = this.model.acompanhante
            this.originalModel.pontoId = this.model.pontoId
            this.originalModel.dataSaida = Array.isArray(this.model.dataSaida) ? this.model.dataSaida[0] : this.model.dataSaida
            this.originalModel.horarioSaida = moment(this.model.horarioSaida, "HH:mm").format("HH:mm")
            this.originalModel.tipoPassageiroId = this.model.tipoPassageiroId
            this.originalModel.veiculoId = this.model.veiculoId
            this.originalModel.jornadaId = isNaN(this.model.jornadaId) ? null : this.model.jornadaId;
            this.originalModel.observacao = (this.model.observacao || '').trim()
        },
        validarDataEHora() {

            const formattedData = this.getFormatedDate(this.model.data, 'YYYY-MM-DD')
            const formattedDataSaida = this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD')

            if (formattedData === formattedDataSaida) {

                if (this.model.horarioSaida) {

                    return this.model.horario > this.model.horarioSaida
                } else {

                    return true
                }
            } else {

                return true
            }
        },
        handleExit() {

            this.$emit('handleExitSupervisor')

            this.$refs.RkmModalPermissao.hide()
        },
        getMaxHour() {

            const horario = this.model.horario

            if (horario) {

                return moment(horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm')
            }

            return false
        },
        formatDate() {

            const data = this.model.data

            if (data) {

                return moment(data, 'DD/MM/YYYY').format('DD/MM/YYYY')
            }

            return ''
        },
        showVeiculo() {

            return this.agendarTransporteJornada && this.model.jornadaId
                || !this.agendarTransporteJornada && this.model.veiculoId
        },
        getDestinos() {

            this.setLoading()

            this.repositories.agendar.getDestinos({
                'municipio_id': this.model.municipioId
            })
                .then(({ data }) => {

                    this.destinos = data

                    if (this.destinos.length === 0) {

                        this.showAlert(`Para prosseguir, é necessário cadastrar um destino para a cidade informada,
                            pois não há nenhum destino registrado atualmente.`, 'Atenção')

                        return
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getTiposPassageiro() {

            this.model.tipoPassageiroId = null
            this.tiposPassageiro = []

            if (this.validarDataEHora()) {

                this.setLoading()

                const dataSaida = this.model.dataSaida[0]

                this.repositories.agendar.getTiposPassageiros({
                    'data_saida': this.getFormatedDate(dataSaida, 'YYYY-MM-DD'),
                    'horario_saida': this.model.horarioSaida,
                })
                    .then(({ data }) => {

                        if (data.length > 0) {

                            this.tiposPassageiro = data
                        } else {

                            if (this.agendarTransporteJornada) {

                                this.showAlert(
                                    'Não foi possível encontrar nenhuma jornada para a data e horário de saída informados.', 'Atenção',
                                )
                            }
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        loadMotivo(motivo) {

            this.$nextTick(() => this.model.motivo = motivo)
        },
        handlePermission(supervisorId){

            this.model.supervisorId = supervisorId
            this.supervisorId = supervisorId

            this.alterar()
        },
        alterar() {
            const ids = Array.isArray(this.model.id) ? this.model.id : [this.model.id]
            const datasSaida = Array.isArray(this.model.dataSaida) ? this.model.dataSaida : [this.model.dataSaida]

            ids.forEach(async (id, index) => {

                const dataSaidaCorrespondente = datasSaida[index]

                const currentModel = {
                    ...this.model,
                    id,
                    dataSaida: dataSaidaCorrespondente
                }

                this.$refs.RkmForm.validate().then(valid => {

                    if (valid) {

                        if (!this.validateForm()) {

                            return
                        }

                        const dataHoraSaida = this.getFormatedDate(
                            currentModel.dataSaida,
                            "YYYY-MM-DD"
                        )

                        const horarioSaida = this.agendamentoPaciente.filter(
                            jornada =>
                                this.getFormatedDate(jornada.dataInicial, "YYYY-MM-DD") <= dataHoraSaida &&
                                this.getFormatedDate(jornada.dataFinal, "YYYY-MM-DD") >= dataHoraSaida
                        )

                        currentModel.destino = this.destinos.find(u => u.id === currentModel.destinoId).descricao
                        currentModel.municipio.id = currentModel.municipioId
                        currentModel.municipio.nome = this.municipios.find(u => u.id === currentModel.municipioId).nome

                        const veiculo = this.veiculos.find(u => u.id === currentModel.veiculoId)

                        if (veiculo) {

                            currentModel.numeroPlaca = veiculo.descricao.split(" - ")[0]
                            currentModel.descricaoModelo = veiculo.descricao.split(" - ")[1]
                        }

                        currentModel.ponto = this.pontos.find(u => u.id === currentModel.pontoId).descricao

                        currentModel.data = this.getFormatedDate(currentModel.data, "YYYY-MM-DD")
                        currentModel.dataSaida = this.getFormatedDate(currentModel.dataSaida, "YYYY-MM-DD")
                        currentModel.horario = moment(currentModel.horario, "HH:mm").format("HH:mm")
                        currentModel.horarioSaida = currentModel.horarioSaida
                            ? moment(currentModel.horarioSaida, "HH:mm").format("HH:mm")
                            : null

                        if (horarioSaida.length > 0) {

                            const consultasConflito = horarioSaida.filter(consulta => currentModel.id !== consulta.id)

                            let msg

                            const conflitoDeHorario = consultasConflito.some(
                                consulta =>
                                    this.handlePeriodo(consulta.horario) ===
                                    this.handlePeriodo(currentModel.horario)
                            )

                            if (conflitoDeHorario) {

                                this.showAlert(
                                    `O paciente tem um agendamento para o mesmo dia e turno. Para agendá-lo será necessário cancelar o outro agendamento.`,
                                    "Atenção"
                                )

                                currentModel.jornadaId = null

                                return
                            }

                            if (consultasConflito.length > 0) {

                                msg = "O paciente tem uma ou mais viagens agendadas para o mesmo dia do procedimento escolhido:"

                                consultasConflito.forEach(consulta => {

                                    msg += `<br><br>
                                        Destino: <strong>${consulta.destino} - ${consulta.municipio} - ${consulta.uf}</strong><br>
                                        Data: <strong>${consulta.data} - ${consulta.horario} (${this.handlePeriodo(consulta.horario)})</strong><br>
                                        Motivo da viagem: <strong>${consulta.motivoDescricao}</strong><br>
                                        Horário de saída do veículo: <strong>${consulta.horarioSaida}</strong>`
                                })

                                msg += "<br><br>Deseja continuar?"
                            } else {

                                msg = "Deseja confirmar a alteração da viagem?"
                            }

                            const confirm = async () => {

                                this.save(currentModel)
                            }

                            this.showConfirmation(msg, confirm)
                        } else {

                            this.save(currentModel)
                        }
                    }
                    this.$emit('close-modal')
                })
            })
        },
        save(model) {

            this.setLoading()

            this.repositories.gerenciamento.update(model.id, this.prepareData(model))
                .then(() => {

                    this.model = { ...this.model, ...model }
                    this.showSaveNotification()
                    this.removeWatchers()
                    this.$nextTick().then(() => this.load())
                    this.handlePrint()
                    this.$refs.Modal.hide()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData(model) {

            const jornadasSelecionadas = Array.isArray(this.model.jornadasSelecionadas) ? this.model.jornadasSelecionadas : []

            const jornadasComDataInicial = jornadasSelecionadas.map(jornadaId => {

                const jornada = this.optionsJornada.find(j => j.id === jornadaId)

                return jornada ? { id: jornada.id, dataInicial: this.getFormatedDate(jornada.dataInicial, 'YYYY-MM-DD') } : null
            }).filter(jornada => jornada !== null)

            const jornadaIdValida = jornadasComDataInicial.find(jornada => jornada.dataInicial === model.dataSaida)


            const agendar = [
                {
                    id: model.id,
                    motivo: model.motivo.id,
                    data: model.data,
                    horario: model.horario,
                    municipio: model.municipioId,
                    destino: model.destinoId,
                    consulta_observacao: model.consultaObservacao,
                    acompanhante: model.acompanhante,
                    acompanhante1_id: model.acompanhante1.id,
                    acompanhante1: {
                        id: model.acompanhante1.id,
                        nome: model.acompanhante1.nome,
                        usuario_id: model.acompanhante1.usuarioId,
                        relacao_id: model.acompanhante1.relacaoId,
                        cns: model.acompanhante1.cns,
                        telefone: model.acompanhante1.telefone
                    },
                    acompanhante2_id: model.acompanhante2.id,
                    acompanhante2: {
                        id: model.acompanhante2.id,
                        nome: model.acompanhante2.nome,
                        usuario_id: model.acompanhante2.usuarioId,
                        relacao_id: model.acompanhante2.relacaoId,
                        cns: model.acompanhante2.cns,
                        telefone: model.acompanhante2.telefone
                    },
                    observacao: model.observacao,
                    ponto: model.pontoId,
                    data_saida: model.dataSaida,
                    horario_saida: model.horarioSaida,
                    tipo_passageiro: model.tipoPassageiroId,
                    veiculo_id: model.veiculoId,
                    jornada_id: jornadaIdValida ? jornadaIdValida.id : this.model.jornadasSelecionadas,
                    items_selecionados: model.itemsSelecionados
                }
            ]

            return this.camelObjectKeysToSnakeRecursive({agendar})
        },
        handlePrint() {

            if (!this.model.itemsSelecionados) {

                let agendamento = []

                    let acompanhante1Nome;
                    let acompanhante2Nome;

                    if(this.model.acompanhante1.nome && this.model.acompanhante1.nome.cidadao) {
                        acompanhante1Nome = this.model.acompanhante1.nome.cidadao.nome;
                    } else {
                        acompanhante1Nome = this.model.acompanhante1.nome;
                    }

                    if(this.model.acompanhante2.nome && this.model.acompanhante2.nome.cidadao) {
                        acompanhante2Nome = this.model.acompanhante2.nome.cidadao.nome;
                    } else {
                        acompanhante2Nome = this.model.acompanhante2.nome;
                    }

                    let dataSaidaViagem = Array.isArray(this.model.dataSaida) && this.model.dataSaida.length > 0 ? this.getFormatedDate(this.model.dataSaida[0], 'DD/MM/YYYY') : moment(this.model.dataSaida, 'YYYY-MM-DD').format('DD/MM/YYYY')

                    let viagem = {
                        pacienteNome: this.form.paciente.nome,
                        pacienteNomeSocial: this.form.paciente.nomeSocial,
                        dataNascimento: this.form.paciente.dataNascimento,
                        prontuario: this.form.paciente.prontuario,
                        telefonePaciente: this.form.paciente.telefones,
                        logotipo: this.form.cliente.logotipo,
                        nomePrefeitura: this.form.cliente.nome,
                        ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                        mensagemProtocolo: this.form.mensagemProtocolo,
                        sistemaNome: this.form.cliente.sistema.nome,
                        sistemaVersao: this.form.cliente.sistema.versao,
                        usuario: this.form.usuario,
                        acompanhantes: this.model.acompanhante ? this.model.acompanhante : 'NÃO',
                        dataSaida: dataSaidaViagem,
                        horarioSaida: this.model.horarioSaida
                            ? moment(this.model.horarioSaida, 'HH:mm').format('HH:mm')
                            : 'NÃO INFORMADO',
                        motivo: this.model.motivo.descricao ? this.model.motivo.descricao : "NÃO INFORMADO",
                        ponto: this.model.ponto ? this.model.ponto : "NÃO INFORMADO",
                        destino: this.model.destino ? this.model.destino : "NÃO INFORMADO",
                        veiculo: this.model.veiculoId ? this.model.numeroPlaca + ' - ' + this.model.descricaoModelo : "NÃO INFORMADO",
                        comprovanteAcompanhante: this.form.comprovanteAcompanhante,
                        acompanhante1Nome,
                        acompanhante1Cns: this.model.acompanhante1.cns,
                        acompanhante1Telefone: this.model.acompanhante1.telefone,
                        acompanhante1Relacao: this.model.acompanhante1.relacaoId ? this.form.relacoes.find(relacao => relacao.id == this.model.acompanhante1.relacaoId).descricao : null,
                        acompanhante2Nome,
                        acompanhante2Cns: this.model.acompanhante2.cns,
                        acompanhante2Telefone: this.model.acompanhante2.telefone,
                        acompanhante2Relacao: this.model.acompanhante2.relacaoId ? this.form.relacoes.find(relacao => relacao.id == this.model.acompanhante2.relacaoId).descricao : null,
                        telefoneUnidadeAgendadora: this.form.paciente.telefoneUnidadeAgendadora
                    }

                    agendamento.push(viagem)

                if (agendamento.length > 0) {
                    this.print().agendamentos(agendamento)
                }
            }
        },
        handlePeriodo(horario) {

            if (horario < '12:00') {

                return "Turno da manhã"
            } else if (horario < '18:00') {

                return "Turno da tarde"
            } else {

                return "Turno da noite"
            }
        },
        setFields(value) {

            const index = this.fieldMap.indexOf(value);
            const field = this.fieldMap[index + 1];

            if (field && this.model[field] !== null) {

                if (field !== 'tipoPassageiroId' && field !== 'consultaObservacao' && field !== 'observacao') {
                    for (const ref of Object.values(this.$refs)) {

                        if (ref && ref.validate) {
                            ref.resetValidator();
                        }
                    }

                    this.$set(this.model, field, null);
                    this.setFields(field);
                }
            }
        },
        validateForm() {

            const modelId = Array.isArray(this.model.id) ? this.model.id[0] : this.model.id

            const item = this.items.find(item => item.id === modelId)

            const acompanhanteDoAgendamento = this.model.acompanhante != item.acompanhante
                ? (this.model.acompanhante - item.acompanhante) : 0

            if (this.model.jornadaId && (parseInt(this.model.totalAgendados) + parseInt(acompanhanteDoAgendamento) >= this.model.capacidade) && this.supervisorId == null) {

                const msg = `Para continuar com essa viagem, é necessário que sejam informados os dados
                    do supervisor, uma vez que a quantidade de passageiros excede a capacidade máxima do veículo.
                    Deseja continuar?`

                this.showAlert(msg, 'Atenção')

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()
                }

                this.showConfirmation(msg, confirm)

                return false
            }

            return true
        },
        getVeiculos() {

            this.setLoading()

            this.resetVeiculos()

            const dataSaida = Array.isArray(this.model.dataSaida) ? this.model.dataSaida[0] : this.model.dataSaida

            this.repositories.agendar.getVeiculos({
                'agendar_transporte_jornada': this.agendarTransporteJornada,
                'data_saida': this.getFormatedDate(dataSaida, 'YYYY-MM-DD'),
                'horario_saida': this.model.horarioSaida
            })
                .then(({ data }) => {

                    this.veiculos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDataSaida() {

            if(!this.model.horarioSaida){

                this.setFields('pontoId')
            }
        },
        resetVeiculos() {

            this.veiculos = []

            this.model.veiculoId = null
            this.model.capacidade = null
            this.model.totalAgendados = null
            this.model.tipoVeiculoId = null
        },
        getJornadas() {

            this.model.isMultiple = false
            this.updatingJornadas = true
            this.setLoading()

            const selecionados = this.items.filter(item => item.id)

            let data_horario_saida, data_inicial, data_final

            if (!this.model.itemsSelecionados) {

                data_horario_saida = this.getFormatedDate(this.model.dataSaida[0], 'YYYY-MM-DD')

            } else {

                const selecionadosOrdenados = [...selecionados].sort((a, b) => new Date(a.dataSaida) - new Date(b.dataSaida))
                data_inicial = this.getFormatedDate(selecionadosOrdenados[0]?.dataSaida, 'YYYY-MM-DD')
                data_final = this.getFormatedDate(selecionadosOrdenados[selecionadosOrdenados.length - 1]?.dataSaida, 'YYYY-MM-DD')
            }

            this.repositories.agendar.getJornadas({
                veiculo_id: this.model.veiculoId,
                paciente_id: this.model.pacienteId,
                data_saida: data_horario_saida,
                data_inicial: data_inicial,
                data_final: data_final,
                gerenciamento: true
            })
                .then(({ data }) => {

                    this.jornadas = data

                    if (data.length > 0 && !this.model.isMultiple && !Array.isArray(this.model.optionsJornada) && this.model.veiculoId) {

                        let jornadaSelecionada = data.find(jornada => jornada.id === this.model.jornadaId)
                        this.model.jornadasSelecionadas = jornadaSelecionada  ? jornadaSelecionada.id : null

                    } else {

                        const jornadasSelecionadas = this.optionsJornada.map(jornada => jornada.id)
                        this.model.jornadasSelecionadas = jornadasSelecionadas
                    }
                })
                .catch(this.handleError)
                .finally(() => {
                    this.updatingJornadas = false
                    this.unsetLoading()
                })
        },
        jornadasMultiplas(jornadasFiltradas) {

            const jornadas = Array.isArray(jornadasFiltradas) ? jornadasFiltradas : []

            this.model.jornadasSelecionadas = jornadas.map(jornada => ({
                id: jornada.id,
                dataInicial: `${this.getFormatedDate(jornada.dataInicial, 'YYYY-MM-DD')}`
            }))

            if (jornadas != []) {

                this.model.isMultiple = true
            }
        },
        getAgendadosPaciente() {

            this.setLoading()

            const dataSaida = this.model.dataSaida

            this.repositories.agendar.getAgendadosPaciente({
                'data_saida': `${this.getFormatedDate(dataSaida, 'YYYY-MM-DD')}`,
                'paciente_id': this.model.pacienteId,
            })
                .then(({ data }) => {

                    this.agendamentoPaciente = data

                    this.handleJornada(data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

        },
        handleJornada(data) {

            const agendamentoId = data.find(jornada => jornada.id)
            const jornada = data.find(jornada => jornada.jornadaId === this.model.jornadaId)
            const horario = data.find(jornada => jornada.horario === this.model.horario)
            const horarioSaida = data.find(jornada => jornada.horarioSaida === this.model.horarioSaida)
            const municipio = data.find(jornada => jornada.municipioId === this.model.municipioId)
            const destino = data.find(jornada => jornada.destinoId === this.model.destinoId)
            const veiculo = data.find(jornada => jornada.veiculoId === this.model.veiculoId)
            const dataHoraSaida = this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD') + ' ' + this.model.horarioSaida

            if (jornada && horario && horarioSaida && municipio && destino && this.model.id !== agendamentoId.id) {

                this.showAlert(`Este paciente já está agendado nesta jornada (mesmo veículo e horário), portanto não é
                    necessário cadastrá-lo novamente.`, 'Atenção')

                this.model.jornadaId = null

                return
            } else if (dataHoraSaida) {

                const jornadaInvalida = data.find(jornada => jornada.dataInicial <= dataHoraSaida && jornada.dataFinal >= dataHoraSaida)

                if (jornadaInvalida && this.model.id !== agendamentoId.id) {

                    this.showAlert(`Este paciente já está agendado em outra jornada (no veículo ${jornadaInvalida.numeroPlaca}
                        - ${jornadaInvalida.descricaoModelo} no mesmo horário). Para agendá-lo será necessário cancelar o
                        outro agendamento.`, 'Atenção')

                    this.model.jornadaId = null

                    return
                } else if (jornadaInvalida && this.model.id != agendamentoId.id && veiculo && jornada && horario && horarioSaida && municipio && destino) {

                    this.showAlert(`Este paciente já está agendado em outra jornada (no veículo ${jornadaInvalida.numeroPlaca}
                        - ${jornadaInvalida.descricaoModelo} no mesmo horário). Para agendá-lo será necessário cancelar o
                        outro agendamento.`, 'Atenção')

                    this.model.jornadaId = null

                    return
                }
            }
        },
        handlePhone(obj) {

            let telefones = ''

            Object.keys(obj).forEach(function(value, i) {

                if (i === 0) {
                    telefones = telefones.concat(obj[value])
                } else {
                    telefones = telefones.concat(`, ${obj[value]}`)
                }
            });

            return telefones
        },
        handleAcompanhante() {

            if (this.model.acompanhante == 0) {

                this.model.acompanhante1.usuarioId = null
                this.model.acompanhante1.nome = null
                this.model.acompanhante1.cnd = null
                this.model.acompanhante1.telefone = null
                this.model.acompanhante1.relacaoId = null
                this.model.acompanhante1Id = null

                this.model.acompanhante2.usuarioId = null
                this.model.acompanhante2.nome = null
                this.model.acompanhante2.cnd = null
                this.model.acompanhante2.telefone = null
                this.model.acompanhante2.relacaoId = null
                this.model.acompanhante2Id = null
            } else if (this.model.acompanhante == 1) {

                this.model.acompanhante2.usuarioId = null
                this.model.acompanhante2.nome = null
                this.model.acompanhante2.cnd = null
                this.model.acompanhante2.telefone = null
                this.model.acompanhante2.relacaoId = null
                this.model.acompanhante2Id = null
            }
        },
        removeWatchers() {

            this.watchers.forEach(watch => watch())
        },
        addWatchers() {

            this.watchers = []

            this.watchers.push(this.$watch('model.data', function (data) {

                if (data) {

                    this.model.dataSaida = data
                }

            }, { immediate: false }))

            this.watchers.push(this.$watch('model.municipioId', function (municipioId) {

                if (municipioId) {

                    this.getDestinos()

                    if (!this.form.agendarTransporteJornada) {

                        this.getVeiculos()
                    }
                }

                this.setFields('municipioId')
            }, { immediate: false }))

            this.watchers.push(this.$watch('model.dataSaida', function (dataSaida) {

                if (dataSaida) {

                    this.getVeiculos()
                    this.getAgendadosPaciente()

                    this.model.horarioSaida = null
                }

                this.setFields('pontoId')
            }, { immediate: false }))

            this.watchers.push(this.$watch('model.horarioSaida', function () {

                this.setFields('horarioSaida')

            }, { immediate: false }))

            this.watchers.push(this.$watch('model.acompanhante1.nome', function (acompanhante) {

                if (this.form.paciente.requiredAcompanhante && acompanhante) {

                    if (acompanhante.cidadao.idade.anos > 80 || acompanhante.cidadao.idade.anos < 8) {

                        this.showAlert('O acompanhante deve estar na faixa etária entre 08 e 80 anos.', 'Atenção!')

                        this.model.acompanhante1.nome = null
                        this.model.acompanhante1.cns = null
                        this.model.acompanhante1.telefone = null
                        this.model.acompanhante1.usuarioId = null

                        return false
                    }

                    if (!acompanhante.cidadao.cns || !this.utils.validaCns(acompanhante.cidadao.cns) || !acompanhante.cidadao.dataNascimento || !acompanhante.cidadao.sexo.id
                        || !acompanhante.cidadao.nome || !acompanhante.cidadao.nacionalidadeId || !acompanhante.cidadao.domicilioId || !acompanhante.cidadao.racaCorId
                        || acompanhante.cidadao.racaCorId == this.enums.racaCor.INDIGENA && !acompanhante.cidadao.etniaIndigenaId
                        || acompanhante.cidadao.telefones.length === 0){

                            const confirm = async () => {

                                if (acompanhante) {

                                    this.model.acompanhante1.cns = acompanhante.cidadao ? acompanhante.cidadao.cns : null
                                    this.model.acompanhante1.telefone = acompanhante.cidadao ? this.handlePhone(acompanhante.cidadao.telefonePrincipal.numero) : null;
                                    this.model.acompanhante1.usuarioId = acompanhante.id ? acompanhante.id : null
                                } else {

                                    this.model.acompanhante1.nome = null
                                    this.model.acompanhante1.cns = null
                                    this.model.acompanhante1.telefone = null
                                    this.model.acompanhante1.usuarioId = null
                                }
                            }

                            const cancel = async () => {

                                this.model.acompanhante1.nome = null
                                this.model.acompanhante1.cns = null
                                this.model.acompanhante1.telefone = null
                                this.model.acompanhante1.usuarioId = null
                            }

                            const msg = `O cadastro do(a) acompanhante selecionado(a) está incompleto e a viagem não
                                será faturada. Deseja continuar?`

                                this.showConfirmation(msg, confirm, cancel)

                            return false
                    } else {

                        if (acompanhante) {

                            this.model.acompanhante1.cns = acompanhante.cidadao ? acompanhante.cidadao.cns : null
                            this.model.acompanhante1.telefone = acompanhante.cidadao ? this.handlePhone(acompanhante.cidadao.telefonePrincipal.numero) : null;
                            this.model.acompanhante1.usuarioId = acompanhante.id ? acompanhante.id : null

                        } else {

                            this.model.acompanhante1.nome = null
                            this.model.acompanhante1.cns = null
                            this.model.acompanhante1.telefone = null
                            this.model.acompanhante1.usuarioId = null
                        }
                    }
                } else {

                    if (acompanhante) {

                        this.model.acompanhante1.cns = acompanhante.cidadao ? acompanhante.cidadao.cns : null
                        this.model.acompanhante1.telefone = acompanhante.cidadao ? this.handlePhone(acompanhante.cidadao.telefonePrincipal.numero) : null;
                        this.model.acompanhante1.usuarioId = acompanhante.id ? acompanhante.id : null
                    } else {

                        this.model.acompanhante1.nome = null
                        this.model.acompanhante1.cns = null
                        this.model.acompanhante1.telefone = null
                        this.model.acompanhante1.usuarioId = null
                    }
                }
            }, { immediate: false }))

            this.watchers.push(this.$watch('model.acompanhante2.nome', function (acompanhante) {

                if (acompanhante) {

                    this.model.acompanhante2.cns = acompanhante.cidadao ? acompanhante.cidadao.cns : null
                    this.model.acompanhante2.telefone = acompanhante.cidadao ? this.handlePhone(acompanhante.cidadao.telefonePrincipal.numero) : null
                    this.model.acompanhante2.usuarioId = acompanhante.id ? acompanhante.id : null
                } else {

                    this.model.acompanhante2.cns = null
                    this.model.acompanhante2.telefone = null
                    this.model.acompanhante2.relacaoId = null
                }
            }, { immediate: false }))

            this.watchers.push(this.$watch('model.veiculoId', function (tipoVeiculo) {

                if (tipoVeiculo) {

                    this.getJornadas()

                    this.model.capacidade = null
                    this.model.totalAgendados = null
                    this.model.tipoVeiculoId = null

                    const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                    this.model.capacidade = veiculo.capacidade
                    this.model.totalAgendados = veiculo.agendados
                        ? (Number(veiculo.agendados.quantidade) - Number(this.model.acompanhante)) - 1
                        : 0
                    this.model.tipoVeiculoId = veiculo.tipoId
                } else {
                    this.getJornadas()
                }
            }, { immediate: false }))
            this.watchers.push(this.$watch('model.jornadasSelecionadas', function (jornadasSelecionadas) {

                if(jornadasSelecionadas){
                    this.getAgendadosPaciente()

                    this.model.capacidade = null
                    this.model.totalAgendados = null
                    this.model.tipoVeiculoId = null

                    const jornada = this.jornadas.find(jornada => jornada.id === jornadasSelecionadas)

                    if (jornada) {
                        this.model.capacidade = jornada.numeroCapacidade ?? null
                        this.model.totalAgendados = jornada.totalAgendados ?? null
                        this.model.tipoVeiculoId = jornada.tipoId ?? null
                    }

                    if (jornada && !this.model.veiculoId) {
                        const veiculo = this.veiculos.find(v => v.id === jornada.veiculoId)

                        if (veiculo) {
                            this.model.veiculoId = jornada.veiculoId ?? null
                        }
                    }
                    this.model.jornadaId = jornadasSelecionadas
                }
                else {

                        this.model.capacidade = null
                        this.model.totalAgendados = null
                        this.model.tipoVeiculoId = null

                        const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                        if (veiculo) {

                            this.model.capacidade = veiculo.capacidade
                            this.model.totalAgendados = veiculo.agendados
                                ? (Number(veiculo.agendados.quantidade) - Number(this.model.acompanhante)) - 1
                                : 0
                            this.model.tipoVeiculoId = veiculo.tipoId
                        }
                }
            }, { immediate: false }));
        }
    },
    mixins: [ error, repository, stringCase, data, object, printTransportePacienteAgendar, mask ],
    props: {
        paciente: { type: Object, required: true },
        items: { type: Array, required: true },
        agendarTransporteJornada: { type: Boolean, default: false },
        pontos: { type: Array, required: true },
        municipios: { type: Array, required: true }
    },
}
</script>